import SetlistDisplay from 'components/Setlist/obs';
import React from 'react';

const SetlistDisplayPage: React.FC = () => {
  return <SetlistDisplay />;
};

export default SetlistDisplayPage;
